import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Medical = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M13.0709 8C13.5561 4.60771 16.4735 2 20 2C23.5265 2 26.4439 4.60771 26.9291 8H31C33.7614 8 36 10.2386 36 13V27C36 29.7614 33.7614 32 31 32H9C6.23858 32 4 29.7614 4 27V13C4 10.2386 6.23858 8 9 8H13.0709ZM15.1 8H24.9C24.4367 5.71776 22.419 4 20 4C17.581 4 15.5633 5.71776 15.1 8ZM9 10C7.34315 10 6 11.3431 6 13V27C6 28.6569 7.34315 30 9 30H31C32.6569 30 34 28.6569 34 27V13C34 11.3431 32.6569 10 31 10H9ZM20 15C20.5523 15 21 15.4477 21 16V19H24C24.5523 19 25 19.4477 25 20C25 20.5523 24.5523 21 24 21H21V24C21 24.5523 20.5523 25 20 25C19.4477 25 19 24.5523 19 24V21H16C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19H19V16C19 15.4477 19.4477 15 20 15Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Medical;
